import {
  PEOPLE_RANKING_GET,
  CLOSED_ORDERS_FILTER_ASC,
  CLOSED_ORDERS_FILTER_DESC
} from "./mutation-types";
import { loaderDone, loaderStart } from "@/services/LoaderService";
import { errorMessage, showMessage } from "@/services/MessageService";
import { firestore } from "@/config/firebase";
export default {
  async getPeopleRanking({ commit }, branch) {
    loaderStart();
    try {
      const peopleQuerySnapshot = await firestore("dynamic-board")
        .doc("people-ranking")
        .collection("items")
        .orderBy("lastUpdate", "desc")
        .limit(1)
        .get();
      if (!peopleQuerySnapshot.empty) {
        const lastPeopleUpdateDate = peopleQuerySnapshot.docs[0]?.data()
          ?.lastUpdate;
        if (branch) {
          const branchMap = (await firestore("dynamic-board")
            .doc("commun")
            .get()).data().peopleToProductVenues;
          const people = await firestore("dynamic-board")
            .doc("people-ranking")
            .collection("items")
            .where("venueId", "==", branchMap[branch])
            .where("lastUpdate", "==", lastPeopleUpdateDate);
          people.onSnapshot(peopleData => {
            commit(PEOPLE_RANKING_GET, { peopleData, branch });
          });
        } else {
          const people = await firestore("dynamic-board")
            .doc("people-ranking")
            .collection("items")
            .where("lastUpdate", "==", lastPeopleUpdateDate);
          people.onSnapshot(peopleData => {
            commit(PEOPLE_RANKING_GET, { peopleData });
          });
        }
      } else {
        showMessage({
          message: "No se han encontrado datos del personal",
          color: "orange lighten-1"
        });
      }
    } catch (error) {
      errorMessage("Ha ocurrido un error al consultar los datos del personal");
    } finally {
      loaderDone();
    }
  },
  closedOrdersAsc({ commit }) {
    commit(CLOSED_ORDERS_FILTER_ASC);
  },
  closedOrdersDesc({ commit }) {
    commit(CLOSED_ORDERS_FILTER_DESC);
  }
};
